"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBeginImageUploadBody = void 0;
const validation_1 = require("@fmtk/validation");
const UpdateDeckBody_1 = require("./UpdateDeckBody");
const integerRange_1 = require("../validation/integerRange");
exports.validateBeginImageUploadBody = (0, validation_1.properties)({
    fileName: (0, validation_1.text)(),
    size: (0, integerRange_1.integerRange)(UpdateDeckBody_1.MinImageSize, UpdateDeckBody_1.MaxImageSize),
    type: (0, validation_1.is)(...UpdateDeckBody_1.AllowedImageTypes),
});
//# sourceMappingURL=BeginImageUploadBody.js.map